import Container from "react-bootstrap/Container"
import { Col, Image, Row } from "react-bootstrap"
import React from "react";
import { withRouter } from "react-router-dom"
import styles from "./Home.module.scss"
import { homeContent } from "../../variables"

const Home = () => {
    return (
        <div className="m-2">
            <Container fluid>
                {homeContent.map(row =>
                    <Row className="pb-4" key={row.title}>
                        <Col xs={12}
                             sm={6}
                             md={{offset: row.imageLeft && 2, span: 4}}
                             className={`${styles.imgContainer} box`}>
                            <Image src={row.image.default} className={styles.img} alt={row.image}/>
                        </Col>
                        <Col xs={12}
                             sm={{order: row.imageLeft || "first", span: 6}}
                             md={{order: row.imageLeft || "first", offset: row.imageLeft || 2, span: 4}}
                             className="d-flex flex-column justify-content-center p-2">
                            <div className={styles.descriptionContainer}>
                                <p className={`${styles.title} textFont textMedium`}>{row.title}</p>
                                <p className="textFont textSmall">{row.description}</p>
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    )
}

export default withRouter(Home)